import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getXoxodaySettings } from '../services/giftCardService';
import { XOXODAY_SETTINGS_PATH, getEnvDisplay } from '../constants/giftCard';

// "Xoxoday: LIVE" (red) / "Xoxoday: TEST" (grey), linking to the provider settings page.
// Renders nothing until the active environment is known.
export default function XoxodayEnvBadge() {
  const [environment, setEnvironment] = useState(null);

  useEffect(() => {
    let cancelled = false;

    getXoxodaySettings()
      .then((response) => {
        if (!cancelled) setEnvironment(response?.data?.activeEnvironment || null);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  const env = getEnvDisplay(environment);
  if (!env || environment === 'unknown') return null;

  return (
    <Link
      to={XOXODAY_SETTINGS_PATH}
      className={`gc-env-badge ${env.className} gc-provider-badge`}
      title="Gift card provider settings"
    >
      Xoxoday: {env.label}
    </Link>
  );
}
